export const ACTIVITY_FILTERS_GLOBAL_KEY = 'global::job.activity';

/**
 * Reads persisted activity filters from localStorage synchronously.
 * Used for lazy initialization to prevent flash on initial render.
 * IMPORTANT: At this point we do NOT know the current tenant yet.
 * To avoid loading another tenant's filters, only read the global key here.
 * The tenant-scoped value is applied later once tenant context is ready.
 */
export function getPersistedFiltersSync(): string {
  if (typeof window === 'undefined') return '';

  try {
    const globalValue = window.localStorage.getItem(
      ACTIVITY_FILTERS_GLOBAL_KEY
    );
    if (globalValue) {
      return globalValue;
    }
  } catch (error) {
    console.error('[Activity Filters] Error reading localStorage:', error);
  }

  return '';
}
